module.exports = __webpack_public_path__ + "img/Vector (4).8bd9c56c.svg";